import {FileModel, INTRODUCER_KEY_TYPE, RECOMMENDED_CUSTOMER_INFO, TaxAccountantNameModel} from "@/shared/model";
import * as z from "zod";

const commonSchema = z.object({
	managerId: z.string(),
	department: z.string().nullable(),
	introducerType: INTRODUCER_KEY_TYPE,
	introducedDate: z.string().nullable(),

	introducedCustomerId: z.string().nullable(),
	introducedStoreName: z.string().nullable(),
	introducedRepresentativeName: z.string().nullable(),
	introducedTelephone: z.string().nullable(),

	memo: z.string().nullable(),
	content: z.string(),
	files: z.array(FileModel.model).optional()
});

const taxAccountantScheme = commonSchema.extend({
	introducerType: z.literal("TAX_ACCOUNTANT"),
	introducerTaxAccountant: TaxAccountantNameModel.model.nullable()
});

// "TP", "ACQUAINTANCE", "ETC"
const customerScheme = commonSchema.extend({
	introducerType: z.union([z.literal("TP"), z.literal("ACQUAINTANCE"), z.literal("ETC")]),
	introducerCustomer: RECOMMENDED_CUSTOMER_INFO.nullable()
});

const employeeScheme = commonSchema.extend({
	introducerType: z.literal("MYSELF"),
	introducerEmployeeId: z.string().nullable()
});

const schema = z.discriminatedUnion("introducerType", [taxAccountantScheme, customerScheme, employeeScheme]);

const model = schema.transform((values) => ({
	...values
}));

export const CustomerManagementRegisterFormV2Model = {schema, model};
export type ICustomerManagementRegisterFormV2Model = z.infer<typeof CustomerManagementRegisterFormV2Model.model>;
export const DEFAULT_CUSTOMER_MANAGEMENT_REGISTER: ICustomerManagementRegisterFormV2Model = {
	managerId: "",
	department: "",

	introducerType: "TAX_ACCOUNTANT",
	introducerTaxAccountant: null,

	introducedDate: "",
	introducedCustomerId: null,
	introducedStoreName: null,
	introducedRepresentativeName: null,
	introducedTelephone: null,

	memo: "",
	content: "",
	files: []
};
